import { BasePropertyApi } from './base-api.interface';
import { getFontSize } from './get-common-properties';
import { updateFontSize } from './update-common-properties';

export const fontSizeAPI: BasePropertyApi = {
  get: getFontSize,
  update: updateFontSize,
};
